import { render, staticRenderFns } from "./EditMarketText.vue?vue&type=template&id=34ef8ab6"
import script from "./EditMarketText.vue?vue&type=script&lang=js"
export * from "./EditMarketText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports